import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Link } from 'react-router-dom';
import './ScrollableNav.css';

const ScrollableNav = () => {
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const navRef = useRef(null);
  const menuRef = useRef(null);

  // Navigation items
  const navItems = useMemo(() => [
    { name: 'Home', path: '/app' },
    { name: 'Contact Us', path: '/contact-us' }
  ], []);

  // Check if arrows should be shown
  const checkForArrows = () => {
    if (!menuRef.current) return;
    
    const { scrollLeft, scrollWidth, clientWidth } = menuRef.current;
    
    // Show left arrow if scrolled to the right
    setShowLeftArrow(scrollLeft > 0);
    
    // Show right arrow if there's more content to the right
    setShowRightArrow(scrollLeft + clientWidth < scrollWidth - 5); // 5px buffer
  };

  // Scroll left
  const scrollLeft = () => {
    if (!menuRef.current) return;
    menuRef.current.scrollBy({ left: -200, behavior: 'smooth' });
  };

  // Scroll right
  const scrollRight = () => {
    if (!menuRef.current) return;
    menuRef.current.scrollBy({ left: 200, behavior: 'smooth' });
  };

  // Set up scroll event listener
  useEffect(() => {
    const menuElement = menuRef.current;
    if (!menuElement) return;
    
    // Initial check
    checkForArrows();
    
    // Add scroll event listener
    menuElement.addEventListener('scroll', checkForArrows);
    
    // Check on resize
    window.addEventListener('resize', checkForArrows);
    
    return () => {
      menuElement.removeEventListener('scroll', checkForArrows);
      window.removeEventListener('resize', checkForArrows);
    };
  }, []);

  return (
    <nav className="scrollable-nav" ref={navRef}>
      {showLeftArrow && (
        <button 
          className="nav-arrow left-arrow" 
          onClick={scrollLeft}
          aria-label="Scroll left"
        >
          ‹
        </button>
      )}
      
      <div className="menu-container" ref={menuRef}>
        {navItems.map((item, index) => (
          <div className="nav-item" key={index}>
            {item.external ? (
              <a href={item.path}>{item.name}</a>
            ) : (
              <Link to={item.path}>{item.name}</Link>
            )}
          </div>
        ))}
      </div>
      
      {showRightArrow && (
        <button 
          className="nav-arrow right-arrow" 
          onClick={scrollRight}
          aria-label="Scroll right"
        >
          ›
        </button>
      )}
    </nav>
  );
};

export default ScrollableNav;